import axios from 'axios'
import { API_KEY, API_URL } from '../keys'
import AttributeProductEntity from '@/entities/api/products/attributes'

export const createAttribute = async (
	token: string,
	productId: string,
	attributeData: Partial<AttributeProductEntity>,
	imageFile: File
) => {
	const formData = new FormData()
	formData.append('attributeData', JSON.stringify(attributeData))

	formData.append('files', imageFile)

	const response = await axios.patch(
		`${API_URL}/products/attributes/create/${productId}`,
		formData,
		{
			headers: {
				Authorization: `Bearer ${token}`,
				'sce-api-users-key-validation': API_KEY,
				'Content-Type': 'multipart/form-data',
			},
		}
	)

	if (response) return response
}

export const deleteAttributeById = async (
	token: string,
	productId: string,
	attributeId: string
) => {
	const response = await axios.delete(
		`${API_URL}/products/attributes/delete?productId=${productId}&attributeId=${attributeId}`,
		{
			headers: {
				Authorization: `Bearer ${token}`,
				'sce-api-users-key-validation': API_KEY,
				'Content-Type': 'application/json',
			},
			validateStatus: (status) => status < 500,
		}
	)
	if (response) return response
}

export const updateAttributeById = async (token : string, productId : string, attributeId : string, attribute : Partial<AttributeProductEntity>) => {
	const response = await axios.patch(
		`${API_URL}/products/attributes/update?productId=${productId}&attributeId=${attributeId}`,
		attribute,
		{
			headers: {
				Authorization: `Bearer ${token}`,
				'sce-api-users-key-validation': API_KEY,
				'Content-Type': 'application/json',
			},
			validateStatus: (status) => status < 500,
		}
	)
	if (response) return response
}
